import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

const useScrollToLocation = () => {
    const scrolledRef = React.useRef(false);
    const { hash } = useLocation();
    const hashRef = React.useRef(hash);

    useEffect(() => {
        if (hash) {
            if (hashRef.current !== hash) {
                hashRef.current = hash;
                scrolledRef.current = false;
            }

            if (!scrolledRef.current) {
                const id = hash.replace('#', '');
                const ref = document.getElementById(id);
                const offset = 100;
                if (ref) {
                    window.scrollTo({
                        top: ref.offsetTop - offset,
                        behavior: 'smooth',
                    });
                    scrolledRef.current = true;
                }
            }
        }
    });
};

export default useScrollToLocation;